// PRD 05 §3.1 — disease filter at the top of the tree panel. Hierarchical
// `<select>` with two fixed rows (All / Common only) followed by one optgroup
// per disease group, with a "All in <group>" row plus each ICD code.

import { useTranslation } from 'react-i18next';

import { useDiseaseFilterOptionsQuery } from '../hooks/use-disease-filter-options';
import { useQuestionnaireDesignPageStore } from '../store/questionnaire-design-page.store';

export function QuestionnaireDiseaseFilter() {
  const { t } = useTranslation('questionnaire-design');
  const { data, isLoading } = useDiseaseFilterOptionsQuery();
  const diseaseFilter = useQuestionnaireDesignPageStore((s) => s.diseaseFilter);
  const setDiseaseFilter = useQuestionnaireDesignPageStore(
    (s) => s.setDiseaseFilter,
  );

  return (
    <div
      style={{
        padding: '10px var(--space-4)',
        borderBottom: '1px solid var(--border)',
        background: '#f0f4ff',
      }}
    >
      <label
        style={{
          fontSize: 10,
          fontWeight: 600,
          color: 'var(--muted-foreground)',
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          display: 'block',
          marginBottom: 4,
        }}
      >
        {t('filter.label')}
      </label>
      <select
        className="form-field__select"
        value={diseaseFilter}
        onChange={(e) => setDiseaseFilter(e.target.value)}
        disabled={isLoading}
        style={{ fontSize: 'var(--font-size-xs)', height: 32, padding: '0 8px' }}
        aria-label={t('filter.placeholder')}
      >
        <option value="">{t('filter.all')}</option>
        <option value="COMMON">{t('filter.commonOnly')}</option>
        {(data ?? []).map(({ group, codes }) => (
          <optgroup
            key={group.id}
            label={`${group.name} (${group.rangeStart}~${group.rangeEnd})`}
          >
            <option value={`GRP:${group.name}`}>
              {t('filter.groupAll', { name: group.name })}
            </option>
            {codes
              .filter((c) => c.status === 'ACTIVE')
              .map((c) => (
                <option key={c.id} value={c.code}>
                  {c.code} {c.name}
                </option>
              ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
}
